module.exports = __webpack_public_path__ + "static/media/09_hero_desktop.30388224.jpg";